
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUItemBOMGrid extends Serenity.EntityGrid<SKUItemBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUItemBOM'; }
        protected getDialogType() { return SKUItemBOMDialog; }
        protected getIdProperty() { return SKUItemBOMRow.idProperty; }
        protected getInsertPermission() { return SKUItemBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUItemBOMRow.localTextPrefix; }
        protected getService() { return SKUItemBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}